const capitalize = (str: any) => {
  if (!str || typeof str !== "string" || str.trim() === "") return "";
  return str.trim().replace(/\b\w/g, (l) => l.toUpperCase());
};

export default capitalize;
